import React from "react";
import { processInt, processPassword, processStrWithSpace } from "../../global";



const Useradd = ({ data, updateData, subaccounts, pages, setSubPages, setViewType, subPages,
    getSubAccountsLocations, editSubAccountLocation, removeSubAccount, onSave, userIdAvailable, userIdAvailed, selectAllPages }) => {

    return (
        <>
            <div className="section-header">
                <h1>User</h1>
            </div>
            <div className="card" style={{ padding: 10 }}>
                <div style={{ textAlign: 'right' }}><button type='button' className='btn btn-sm btn-primary' onClick={() => setViewType('list')}>Back</button></div>
                <div className="row">
                    {/* <div className="col-lg-3 col-sm-12">
                        <label>Name</label>
                        <input type="text" className="form-control" maxLength={49} value={data.name} onInput={processStrWithSpace} onChange={e => updateData('name', e.target.value)} />
                    </div> */}
                    <div className="col-lg-3 col-sm-12">
                        <label>CNIC</label>
                        <input type="text" className="form-control" maxLength={13} value={data.cnic} onInput={processInt} onChange={e => updateData('cnic', e.target.value)} />
                    </div>
                    <div className="col-lg-3 col-sm-12">
                        <label>User Id</label>
                        <input type="text" className="form-control" maxLength={49} value={data.userId} onInput={processPassword} onChange={e => updateData('userId', e.target.value)} onBlur={(e) => userIdAvailable(e.target.value)} />
                    </div>
                    <div className="col-lg-3 col-sm-12">
                        <label>Availibility</label>
                        <div>
                            {
                                userIdAvailed === "" ? <></> : userIdAvailed === "true" ? <label style={{ color: 'red' }}>User ID not available</label> : <label style={{ color: 'green' }}>User ID available.</label>
                            }
                        </div>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-lg-2 col-sm-12">
                        <label>Password</label>
                        <input type="text" className="form-control" disabled maxLength={15} value={data.password} />
                    </div>
                    {/* <div className="col-lg-2 col-sm-12">
                        <label>Retype Password</label>
                        <input type="text" className="form-control" maxLength={15} value={data.retypePassword} onInput={processPassword} onChange={e => updateData('retypePassword', e.target.value)} />
                    </div> */}
                    <div className="col-lg-3 col-sm-12">
                        <label>Email</label>
                        <input type="text" className="form-control" maxLength={49} value={data.email} onChange={e => updateData('email', e.target.value)} />
                    </div>
                    <div className="col-lg-2 col-sm-12">
                        <label style={{ whiteSpace: 'nowrap' }}>Zero COD Allowed</label><br />
                        <label className="switch">
                            <input type="checkbox" checked={data.isZeroCodAllowed} onChange={e => updateData('isZeroCodAllowed', e.target.checked)} />
                            <span className="slider round"></span>
                        </label>
                    </div>
                    <div className="col-lg-2 col-sm-12">
                        <label style={{ whiteSpace: 'nowrap' }}>Duplicate Reference No Allowed</label><br />
                        <label className="switch">
                            <input type="checkbox" checked={data.isDuplicateOrderAllowed} onChange={e => updateData('isDuplicateOrderAllowed', e.target.checked)} />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="row mt-4 section-border">
                        <h3 style={{ margin: '10px' }}>Add Sub Accounts</h3>

                        <div className="card" style={{ padding: 10, width: '60%', margin: 'auto' }}>
                            {
                                subaccounts && subaccounts.length > 0 &&
                                <>
                                    <table className='table table-md table-bordered'>
                                        <thead>
                                            <tr>
                                                <th>Id</th>
                                                <th>Sub Account</th>
                                                <th>Edit</th>
                                                <th>Remove</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                subaccounts.map((e, index) =>
                                                    <tr key={index}>
                                                        <td>{e.id}</td>
                                                        <td>
                                                            <div key={index}>
                                                                <label className="small-switch">
                                                                    <input type="checkbox" name={e.info.shipperName} value={e.id} checked={data.subAccounts.includes(Number(e.id))} onChange={c => {
                                                                        if (c.target.checked) {
                                                                            getSubAccountsLocations(e.id, e.info.shipperName)
                                                                        }
                                                                    }} />
                                                                    <span className="small-slider round"></span>
                                                                </label>
                                                                <label className="small-content-check">{e.info.shipperName}</label>
                                                            </div>
                                                        </td>
                                                        {
                                                            data.subAccounts.includes(Number(e.id)) &&
                                                            <>
                                                                <td>
                                                                    <div><button type='button' className='btn btn-sm btn-primary' onClick={() => editSubAccountLocation(e.id, e.info.shipperName)}>Edit</button></div>
                                                                </td>
                                                                <td>
                                                                    <div><button type='button' className='btn btn-sm btn-primary' onClick={() => removeSubAccount(e.id)}>Remove</button></div>
                                                                </td>
                                                            </>
                                                        }

                                                    </tr>)
                                            }
                                        </tbody>
                                    </table>
                                </>
                            }
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-lg-3 col-sm-12">
                            <label>Pages</label>
                            <select className="form-select" onChange={e => { setSubPages(pages.length > 0 ? pages.find(f => f.menu === e.target.value).subMenus : []) }}>
                                {
                                    pages.map((x, index) => <option key={index} value={x.menu}>{x.menu}</option>)
                                }
                            </select>
                        </div>

                        <div className="col-lg-2 col-sm-12">
                            <label style={{ whiteSpace: 'nowrap' }}>Select All</label><br />
                            <label className="switch">
                                <input type="checkbox" defaultChecked={data.selectAll} onChange={selectAllPages} />
                                <span className="slider round"></span>
                            </label>
                        </div>
                    </div>
                    {console.log(data.pages)}
                    <div className="row mt-4 ">
                        {
                            subPages.map((e, i) => <div key={i} className="col-lg-3 col-sm-12">
                                <label className="small-switch">
                                    <input type="checkbox" name={e.text} value={e.value} checked={data.pages.includes(Number(e.value))} onChange={c => {
                                        let updatedPages = [];
                                        if (c.target.checked) {
                                            updatedPages = [...data.pages, Number(e.value)]
                                        } else {
                                            updatedPages = data.pages.filter((item) => { return Number(e.value) !== item })
                                        }
                                        console.log(updatedPages)
                                        updateData('pages', updatedPages);
                                    }} />
                                    <span className="small-slider round"></span>
                                </label>
                                <label className="small-content-check">{e.text}</label>
                            </div>)
                        }
                    </div>

                    <div className="row mt-4">
                        <label>Address Label Type</label>
                        <div style={{
                            display: 'flex',
                            flexFlow: 'wrap',
                            justifyContent: 'space-between'
                        }}>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="type" id="type1" checked={data.addressLabelType === 1} onChange={e => {
                                    if (e.target.checked) {
                                        updateData('addressLabelType', 1);
                                    }
                                }} />
                                <label className="form-check-label" htmlFor="type1">All Copies</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="type" id="type2" checked={data.addressLabelType === 2} onChange={e => {
                                    if (e.target.checked) {
                                        updateData('addressLabelType', 2);
                                    }
                                }} />
                                <label className="form-check-label" htmlFor="type2">Consignee Copy Only</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="type" id="type3" checked={data.addressLabelType === 3} onChange={e => {
                                    if (e.target.checked) {
                                        updateData('addressLabelType', 3);
                                    }
                                }} />
                                <label className="form-check-label" htmlFor="type3">2 CN on 1 Page</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="type" id="type4" checked={data.addressLabelType === 4} onChange={e => {
                                    if (e.target.checked) {
                                        updateData('addressLabelType', 4);
                                    }
                                }} />
                                <label className="form-check-label" htmlFor="type4">15x10 Sticker</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="type" id="type5" checked={data.addressLabelType === 5} onChange={e => {
                                    if (e.target.checked) {
                                        updateData('addressLabelType', 5);
                                    }
                                }} />
                                <label className="form-check-label" htmlFor="type5">2x4 Sticker</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="type" id="type6" checked={data.addressLabelType === 6} onChange={e => {
                                    if (e.target.checked) {
                                        updateData('addressLabelType', 6);
                                    }
                                }} />
                                <label className="form-check-label" htmlFor="type6">4x6 Sticker</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg col-sm-12" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                        <button type="button" className="btn btn-primary" onClick={onSave}>Save</button>
                    </div>
                </div>
            </div>
        </>
    )

}

export default Useradd